import * as React from 'react'
import BaseIcon from '../../BaseIcon'

export default class AlertHelp16Icon extends BaseIcon {
  getChildren = () => [
    <path d="M8 0a8 8 0 1 0 8 8 8 8 0 0 0-8-8Zm0 2a1.5 1.5 0 1 1-1.5 1.5A1.5 1.5 0 0 1 8 2Zm1 11.5H8a1 1 0 0 1-1-1v-4h-.5a1 1 0 0 1 0-2H8a1 1 0 0 1 1 1v4a1 1 0 0 1 0 2Z" fill="#3b8fd6"/>
    ]
  getViewBox = () => '0 0 16 16'
}
